import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Play, Pause } from 'lucide-react';

const VideoSection = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section className="py-24 bg-neutral-darkNavy relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-primary-orange font-bold tracking-wider uppercase mb-3">Video Prezentacija</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-white">Pogledajte Proces Pranja</h3>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto relative aspect-video rounded-3xl overflow-hidden shadow-2xl border-4 border-white/10 group cursor-pointer bg-black"
          onClick={togglePlay}
        >
          <video 
            ref={videoRef}
            src="https://i.imgur.com/QvSMYzn.mp4" 
            className="w-full h-full object-cover"
            loop
            playsInline
            poster="https://i.imgur.com/QvSMYzn.jpg" // Fallback poster if available or just let it load
          />
          
          {!isPlaying && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/40 transition-colors">
              <div className="w-24 h-24 bg-primary-orange rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300">
                <Play className="w-10 h-10 text-white ml-1" fill="currentColor" />
              </div>
            </div>
          )}
          
          {isPlaying && (
            <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity">
               <div className="w-12 h-12 bg-black/50 backdrop-blur-md rounded-full flex items-center justify-center">
                 <Pause className="w-5 h-5 text-white" fill="currentColor" />
               </div>
            </div>
          )}
        </motion.div>
      </div>
      
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-20 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-blue rounded-full blur-[100px]" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary-orange rounded-full blur-[100px]" />
      </div>
    </section>
  );
};

export default VideoSection;
